/** Default break length offered from the swipe-to-unlock overlay. */
export const ENFORCEMENT_BREAK_MINUTES = 5;

/** Clock-skew tolerance when matching `suppressedUntil` to an active break pause. */
export const ENFORCEMENT_BREAK_SUPPRESSION_TOLERANCE_MS = 2_000;

/** Milliseconds for a temporary enforcement pause of `durationMinutes`. */
export function enforcementBreakDurationMs(durationMinutes: number): number {
  return durationMinutes * 60 * 1000;
}

/**
 * `suppressedUntil` after a break — always a fresh pause from `nowMs` (replaces any
 * in-flight break; distinct from swipe-to-unlock stop, which sets a far-future value).
 */
export function computeBreakSuppressedUntil(
  _existingSuppressedUntil: number | undefined,
  nowMs: number,
  durationMinutes: number,
): number {
  return nowMs + enforcementBreakDurationMs(durationMinutes);
}

/** True when `suppressedUntil` looks like a temporary break pause, not a full stop. */
export function isBreakPauseSuppression(
  suppressedUntil: number | undefined,
  nowMs: number,
  breakMinutes: number = ENFORCEMENT_BREAK_MINUTES,
): boolean {
  if (suppressedUntil === undefined || nowMs >= suppressedUntil) return false;
  const remainingMs = suppressedUntil - nowMs;
  const maxBreakMs =
    enforcementBreakDurationMs(breakMinutes) + ENFORCEMENT_BREAK_SUPPRESSION_TOLERANCE_MS;
  return remainingMs <= maxBreakMs;
}
